import { TexasPool } from "../../texas_pool";
import { PokerComponent } from "./poker_component";
import { TableHelp } from "../help/table_help";
import TexasSound from "../../texas_sound";

//处理公共牌
const {ccclass, property} = cc._decorator;

//公共牌的数据
interface PokerActionData{
    poker:PokerComponent;//poker的
    pokerIndex:number;//第几张牌
}

@ccclass
export default class CommonPokerComp extends cc.Component {
    @property(cc.Node)
    prefab:cc.Node = null;
    private pokerPool:TexasPool;
    private queue:PokerComponent[];//展示中的公共牌

    onLoad(){
        this.pokerPool = new TexasPool(this.prefab);
        this.queue = [];
    }

    //创建一张牌
    createOnePoker(code:number){
        let pk = this.pokerPool.obtain();
        pk.parent = this.node;
        pk.active = true;
        pk.position = cc.Vec2.ZERO;
        let poker = pk.getComponent(PokerComponent);
        poker.reset();
        poker.code = code;
        return poker;
    }

    enQueue(code:number[],comp?:Function){
        let playQueue = [];//待播放的queue
        for (let i = 0; i < code.length; i++) {
            let data = code[i];
            let pk = this.queue[i];
            if (pk && pk.code == data) {//pk -- 数据
                pk.show();
                //pk.showCardOnly();
                pk.showPoker();//已经存在的直接显示即可
            }else{
                let pk = this.createOnePoker(data);
                pk.code = data;
                playQueue.push(pk);
                this.queue.push(pk);
                pk.hide();
            }     
        }

        if (playQueue.length == 0) {
            if (comp) {
                comp();
            }
        }else{
            this.playAction(playQueue,comp);
        }
    }

    showImmediately(code:number[]){
        for (let i = 0; i < code.length; i++) {
            let data = code[i];
            let pk = this.queue[i];
            if (!pk) {
                pk = this.createOnePoker(data);
                pk.code = data;
                this.queue.push(pk);
            }
            pk.show();//直接显示公共牌
            pk.showCardOnly();
            pk.showPoker();
        }
    }

    //直接显示牌背，然后显示牌值
    private showPokersAction(pokers:PokerComponent[],comp:Function){
        let queue = pokers.concat([]);
        let doAction = false;
            let timeQueue = [];
            for (let i = 0; i < queue.length; i++) {
                let pk = queue[i];
                pk.show();
                pk.showBack();
                if (i == 0) {
                    timeQueue.push(0);
                }else{
                    timeQueue.push(0.4)
                }
            }

            for (let i = 0; i < queue.length; i++) {
                let pk = queue[i];
                TableHelp.showPokerAction(pk.node,0.3,()=>{
                    if (!doAction) {
                        //翻牌
                        let index = 0;
                        let rotateNumb = 0;

                        let doNextAction = (poker:PokerComponent)=>{
                            if (!poker) {
                                return;
                            }
                            TableHelp.delay(this.node,()=>{
                                this.rotateCard(poker,()=>{
                                    rotateNumb++;
                                    index++;
                                    if (rotateNumb == queue.length) {
                                        if (comp) {
                                            comp();
                                        }
                                    }else{
                                        doNextAction(queue[index]);
                                    }
                                });
                            },timeQueue[rotateNumb])
                        }

                        doNextAction(queue[index]);

                        // TableHelp.repeatTimes(this.node,timeQueue,()=>{
                        //     let poker = queue[index];
                        //     this.rotateCard(poker,()=>{
                        //         rotateNumb++;
                        //         if (rotateNumb == queue.length) {
                        //             if (comp) {
                        //                 comp();
                        //             }
                        //         }
                        //     });
                        //     index++;
                        // },()=>{
                       
                        // })
                        doAction = true;
                    }
                });
            }
    }

    //pokers 所有需要显示的牌
    private playAction(pokers:PokerComponent[],comp:Function){
        let queue = pokers.concat([]);
        this.node.stopAllActions();
        let length = queue.length;
        let count = this.queue.length;
        if (length == 5) {//all-in的情况
            //取前面3张
            let pokers = [];
            for (let i = 0; i < 3; i++) {
                pokers.push(queue[i]);
            }

            this.showPokersAction(pokers,()=>{
                if (count == 5) {//all - in
                    let timeQueue = [1,1];
                    for (let i = 3; i < 5; i++) {
                        let pk = queue[i];
                        pk.hide();
                    }
                    let _index = 3;
                    let rotateNumb = 0;

                    let doNextAction = (poker:PokerComponent)=>{
                        if (!poker) {
                            return;
                        }
                        poker.show();
                        poker.showBack();
                        TableHelp.showPokerAction(poker.node,timeQueue[rotateNumb],()=>{
                            this.rotateCard(poker,()=>{
                                rotateNumb++;
                                _index++;
                                if (rotateNumb == 2) {
                                    if (comp) {
                                        comp();
                                    }
                                }else{
                                    doNextAction(queue[_index]);
                                }
                            });
                        })
                    }

                    doNextAction(queue[_index]); 

                }
            })
        }else{
            //第5张
            if (count == 5 ) {//定有第五张
                let pk = [];
                for (let i = 0; i < pokers.length-1; i++) {
                    pk.push(pokers[i]);
                }
                let endPoker = pokers[pokers.length - 1];
                if (pokers.length == 1) {
                    this.repeatTimesAction(endPoker,comp,1.2);
                }else{
                    this.showPokersAction(pk,()=>{
                        this.repeatTimesAction(endPoker,comp,1);
                    });
                }
            }else{
                this.showPokersAction(pokers,comp);
            }
        }
    }

    private repeatTimesAction(pk:PokerComponent,comp:Function,time:number){
        TableHelp.repeatTimes(pk.node,[0],()=>{
            let poker = pk
            poker.show();
            poker.showBack();
            TableHelp.showPokerAction(poker.node,time,()=>{
                this.rotateCard(poker,()=>{
                    if (comp) {
                        comp();
                    }
                });
            })
        },()=>{
      
        })
    }

    private rotateCard(poker:PokerComponent,comp?:Function){
        let node = poker.node;
        let startFunc = ()=>{
            TexasSound.playRotatePoker();
            poker.showPoker();
        }
        let endBack = ()=>{
            if (comp) {
                comp();
            }
        }
        //TableHelp.rotateAction(node,0.2,startFunc,endBack);
        TableHelp.rotateActionScaltoEx(node,0.1,0.2,startFunc,endBack);
    }

    get pokers():PokerComponent[]{
        return this.queue;
    }

    recycleAll(){
        let nodes = this.node.children;
        for (let child of nodes.concat([])) {
            child.active = false;
            this.pokerPool.recycle(child)
        }
        this.queue.length = 0;
        this.queue = [];
    }

    clear(){
        this.pokerPool.clear();
        this.queue.length = 0;
    }

}
